<!--
 * @Description: 开票备注
 * @Date: 2025-05-20 15:57:04
-->
<template>
  <BaseForm ref="formRef" label-position="top" disabled :model="formData">
    <div class="form-dialog__title">
      <h1>开票备注</h1>
    </div>
    <div
      class="form-dialog__content"
      style="grid-template-columns: repeat(1, 1fr)"
    >
      <BaseFormItem label="备注" prop="demand">
        <BaseInput
          class="form-dialog__w280"
          type="textarea"
          placeholder="请输入"
          show-word-limit
          :rows="4"
          :maxlength="120"
          :modelValue="formData.demand"
        ></BaseInput>
      </BaseFormItem>
    </div>
  </BaseForm>
</template>

<script lang="tsx" setup>
import { BaseForm, BaseFormItem, BaseInput } from 'xrk-components';
import { InvoiceApplyDTO } from '@V/invoice/src/data-source/types';

const formData = defineModel<InvoiceApplyDTO>();
</script>
